import {useQuery} from '@tanstack/react-query'
import React, {useEffect} from 'react'
import {QueryCacheKeys} from '../../QueryKey'
import {getPostDetail} from '../../../apis/post/getPostDetail'
import {getAnnouncement} from '../../../apis/advertisement/getAnnouncement'
import {getAnnounceDetail} from '../../../apis/announce/getAnnounceDetail'

const useQueryAnnounceDetail = (id?: string) => {
    const {data, refetch, isLoading} = useQuery({
        queryKey: QueryCacheKeys.announce.getAnnounceDetail(id),
        queryFn: async () => {
            const {data} = await getAnnounceDetail(id)
            return data
        },
        refetchOnWindowFocus: false,
    })

    useEffect(() => {
        refetch()
    }, [])

    return {data, refresh: refetch, isLoading}
}

export default useQueryAnnounceDetail
